import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import RadioContainer from 'form/components/Radio/RadioContainer/RadioContainer';
import { Radio } from '../../components';
import { FormInputWrapper, TextInput } from 'form/infrastructure/reactHookForm';
import styled from 'styled-components';
import { Text } from 'lmc-ui-library-rebrand';

const Span = styled.span`
  font-size: 16px;
  line-height: 26px;
  font-weight: 400;
  color: #2d3540;

  b {
    font-weight: 700;
  }
`;

interface Transform {
  input: (value: any) => any;
  output: (value: any) => any;
}
interface Props {
  transform?: Transform;
  name: string;
  isDisplayFlex?: boolean;
  options: any[]; // to change { option: string, text: string}
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  wrapperStyles?: React.CSSProperties;
  newUi?: boolean;
}

const RadioGroup: React.FC<Props> = ({
  name,
  options,
  isDisplayFlex = false,
  wrapperStyles,
  transform,
  disabled,
  onChange,
  newUi = false,
}) => {
  const { control } = useFormContext<any>();

  const input = (value: any) => {
    return transform && transform.input ? transform.input(value) : value;
  };

  const output = (value: any) => {
    return transform && transform.output ? transform.output(value) : value;
  };

  return (
    <RadioContainer>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <div style={isDisplayFlex ? { display: 'flex', ...wrapperStyles } : wrapperStyles}>
            {options.map((option: any, index: number) => (
              <div key={`option-${index}`}>
                <Radio
                  newUi
                  disabled={disabled}
                  value={input(option.value)}
                  isChecked={input(field.value) === option.value}
                  name={name}
                  onChange={(e) => {
                    field.onChange(output(e.target.value));
                    field.onBlur();

                    if (typeof onChange === 'function') {
                      const event: typeof e = {
                        ...e,
                        target: {
                          ...e.target,
                          value: output(e.target.value),
                        },
                      };
                      onChange(event);
                    }
                  }}>
                  {newUi ? <Text color="var(--color-indigo-t11)">{option.text}</Text> : <Span>{option.text}</Span>}
                </Radio>
                {option.provideMoreDetails && input(field.value) === option.value && (
                  <FormInputWrapper newUi={newUi} title="" name={option.fieldName} style={{ margin: '0' }}>
                    <TextInput newUi={newUi} placeholder="Please specify" />
                  </FormInputWrapper>
                )}
              </div>
            ))}
          </div>
        )}
      />
    </RadioContainer>
  );
};

export default RadioGroup;
